/**
 * TerritoryWorkspace — Shell transicional
 *
 * @remarks
 * Explorador Territorial liviano en construccion.
 * Cuando exista un motor de mapa ligero (Fase 9+), este workspace
 * ofrecera consulta, navegacion, capas basicas y lectura territorial.
 * Mientras tanto, redirige al editor completo en InventoryWorkspace.
 */

import { useNavigate } from 'react-router-dom';
import { WorkspaceShell } from './WorkspaceShell';

export function TerritoryWorkspace(): JSX.Element {
  const navigate = useNavigate();

  return (
    <WorkspaceShell title="Explorador Territorial" status="shell">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          maxWidth: '480px',
          margin: '48px auto 0',
          textAlign: 'center',
        }}
      >
        <h2
          style={{
            margin: 0,
            fontFamily: 'var(--font-brand, Sora, sans-serif)',
            fontSize: '18px',
            fontWeight: 600,
            color: 'var(--text-primary, #f1f5f9)',
          }}
        >
          Explorador Territorial
        </h2>
        <p
          style={{
            margin: 0,
            fontSize: '14px',
            lineHeight: 1.6,
            color: 'var(--text-secondary, #94a3b8)',
          }}
        >
          Un explorador liviano para consultar capas territoriales, navegar la red urbana y
          visualizar el proyecto sin herramientas de edicion.
        </p>
        <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-tertiary, #475569)' }}>
          En construccion. Mientras tanto, el editor completo esta disponible en el Inventario
          Urbano.
        </p>
        <div style={{ display: 'flex', gap: '12px', paddingTop: '8px' }}>
          <button
            type="button"
            style={{
              padding: '8px 20px',
              background: 'transparent',
              border: '1px solid var(--accent-primary, #2fa4b5)',
              borderRadius: 'var(--radius-md, 6px)',
              color: 'var(--accent-primary, #2fa4b5)',
              fontFamily: 'var(--font-body, Inter, sans-serif)',
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer',
            }}
            onClick={() => navigate('/workspaces/inventory')}
          >
            Abrir Inventario Urbano →
          </button>
        </div>
      </div>
    </WorkspaceShell>
  );
}
